import { render, staticRenderFns } from "./countries.vue?vue&type=template&id=52cae3df&scoped=true"
import script from "./countries.vue?vue&type=script&lang=js"
export * from "./countries.vue?vue&type=script&lang=js"
import style0 from "./countries.vue?vue&type=style&index=0&id=52cae3df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cae3df",
  null
  
)

export default component.exports